(function () {
  const ROOT_SELECTOR = "[data-rental-widget]";
  const TRIGGER_SELECTOR = "[data-rental-open]";
  let preloadLink;
  let widgetScriptPromise;

  function preloadWidgetScript(scriptUrl) {
    if (!scriptUrl || preloadLink || document.querySelector(`link[rel="preload"][href="${scriptUrl}"]`)) {
      return;
    }

    preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.as = "script";
    preloadLink.href = scriptUrl;
    preloadLink.crossOrigin = "anonymous";
    document.head.appendChild(preloadLink);
  }

  function loadWidgetScript(scriptUrl) {
    if (!scriptUrl) {
      return Promise.reject(new Error("Missing rental widget script URL."));
    }

    if (widgetScriptPromise) {
      return widgetScriptPromise;
    }

    widgetScriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        `script[data-rental-widget-script="true"][src="${scriptUrl}"]`
      );

      if (existingScript?.dataset.loaded === "true") {
        resolve();
        return;
      }

      const script = existingScript || document.createElement("script");
      script.src = scriptUrl;
      script.defer = true;
      script.dataset.rentalWidgetScript = "true";

      const handleLoad = () => {
        script.dataset.loaded = "true";
        resolve();
      };

      const handleError = () => {
        widgetScriptPromise = undefined;
        reject(new Error("Rental widget script failed to load."));
      };

      script.addEventListener("load", handleLoad, { once: true });
      script.addEventListener("error", handleError, { once: true });

      if (!existingScript) {
        document.head.appendChild(script);
      }
    });

    return widgetScriptPromise;
  }

  function primeWidget(root) {
    if (!root || root.dataset.rentalLoading === "true") {
      return;
    }

    const trigger = root.querySelector(TRIGGER_SELECTOR);
    const originalLabel = trigger?.dataset.originalLabel || trigger?.textContent || "Choose rental dates";

    if (trigger) {
      trigger.dataset.originalLabel = originalLabel;
      trigger.disabled = true;
      trigger.textContent = "Loading rental options...";
    }

    root.dataset.rentalLoading = "true";

    loadWidgetScript(root.dataset.rentalScriptUrl)
      .catch((error) => {
        console.error("[Rental Widget] Could not lazy-load storefront widget.", error);

        if (trigger) {
          trigger.disabled = false;
          trigger.textContent = originalLabel;
        }

        root.dataset.rentalLoading = "false";
      });
  }

  function hydrateWidget(root) {
    if (!root || root.dataset.rentalInitialized === "true") {
      return;
    }

    preloadWidgetScript(root.dataset.rentalScriptUrl);
    loadWidgetScript(root.dataset.rentalScriptUrl).catch((error) => {
      console.error("[Rental Widget] Could not pre-hydrate storefront widget.", error);
    });
  }

  function bindRoot(root) {
    if (!root || root.dataset.rentalLoaderBound === "true") {
      return;
    }

    const trigger = root.querySelector(TRIGGER_SELECTOR);

    if (!trigger) {
      return;
    }

    const activate = () => primeWidget(root);
    const warm = () => hydrateWidget(root);

    root.dataset.rentalLoaderBound = "true";
    trigger.addEventListener("click", activate, { once: true });
    trigger.addEventListener("pointerenter", warm, { once: true });
    trigger.addEventListener("focus", warm, { once: true });
    trigger.addEventListener("touchstart", activate, { once: true, passive: true });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            warm();
            observer.disconnect();
          }
        },
        { rootMargin: "280px 0px" }
      );

      observer.observe(root);
    } else {
      warm();
    }

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(() => warm(), { timeout: 1500 });
    } else {
      window.setTimeout(warm, 900);
    }
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
